import { jsx as _jsx } from "react/jsx-runtime";
import { BaseButton } from './BaseButton';
export const Button = props => _jsx(BaseButton, Object.assign({}, props, { children: props.children }));
